// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-form-field {
  width: 100%;
}

.dashboard-header {
  margin-bottom: 40px;
}
.mat-card {
  margin-bottom: 30px;
}
.total-count-value {
  /* text-align: right; */
}
.total-count-value p,
.total-count-value h1 {
  margin-bottom: 0;
}

.total-count-icon {
  padding: 10px 15px;
  position: absolute;
  border-radius: 5px;
  top: -25px;
}

.total-count-icon .material-icons {
  font-size: 36px;
  color: #fff;
}

.filterByYear {
  border-radius: 40px;
  float: right;
  width: 140px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  border: none;
}

.policies-tab .mat-card {
  cursor: pointer;
  background: transparent;
  box-shadow: none;
}
.policies-tab .mat-card span {
  line-height: 36px;
}
.policies-tab .mat-card.active span {
  border-bottom: 4px solid #da512d;
  display: inline-block;
}

.dashboard-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 40px;
  flex-direction: row;
  gap: 20px;
}

.dashboard-container .mat-card {
  width: 250px;
  margin-bottom: unset !important;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/secure/dashboard/dashboard.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA,w3EAAw3E","sourcesContent":[".mat-form-field {\n  width: 100%;\n}\n\n.dashboard-header {\n  margin-bottom: 40px;\n}\n.mat-card {\n  margin-bottom: 30px;\n}\n.total-count-value {\n  /* text-align: right; */\n}\n.total-count-value p,\n.total-count-value h1 {\n  margin-bottom: 0;\n}\n\n.total-count-icon {\n  padding: 10px 15px;\n  position: absolute;\n  border-radius: 5px;\n  top: -25px;\n}\n\n.total-count-icon .material-icons {\n  font-size: 36px;\n  color: #fff;\n}\n\n.filterByYear {\n  border-radius: 40px;\n  float: right;\n  width: 140px;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n  border: none;\n}\n\n.policies-tab .mat-card {\n  cursor: pointer;\n  background: transparent;\n  box-shadow: none;\n}\n.policies-tab .mat-card span {\n  line-height: 36px;\n}\n.policies-tab .mat-card.active span {\n  border-bottom: 4px solid #da512d;\n  display: inline-block;\n}\n\n.dashboard-container {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  width: 100%;\n  margin-top: 40px;\n  flex-direction: row;\n  gap: 20px;\n}\n\n.dashboard-container .mat-card {\n  width: 250px;\n  margin-bottom: unset !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
